import { PublicKey } from '@solana/web3.js';
import { TOKEN_MINTS } from '@project-serum/serum';
export const _TOKEN_MINTS = [
	{
		address: "1C2EYVrwmoXAGbiKirFFBeDFDYUBHPhDeg9trhibTND",
		"name": "NRA"
	},
	{
		"address": "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v",
		"name": "USDC"
	},
	{
		"address":"So11111111111111111111111111111111111111112",
		"name": "SOL"
	},
	{
		"address":"SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
		"name": "SOLEND"
	},
	{
		"address": "4k3Dyjzvzp8eMZWUXbBCjEvwSkkk59S5iCNLY3QrkX6R",
		"name": "RAY"
	},
	{
		"address": "9n4nbM75f5Ui33ZbPYXn59EwSgE8CGsHtAeTH5YFeJ9E",
		"name": "BTC"
	},
	{
		"address": "7vfCXTUXx5WJV5JADk17DUJ4ksgau7utNKj4b963voxs",
		"name": "WETH"
	},
	{
		"address": "Gz7VkD4MacbEB6yC5XD3HcumEiYx2EtDYYrfikGsvopG",
		"name": "WMATICPO"
	},
	{
		"address": "2wpTofQ8SkACrkZWrZDjXPitYa8AwWgX8AfxdeBRRVLX",
		"name": "WLINK"
	},
	{
		"address":"9gP2kCy3wA1ctvYWQk75guqXuHfrEomqydHLtcTCqiLa",
		"name": "WBNB"
	},
	{
		"address": "KgV1GvrHQmRBY8sHQQeUKwTm2r2h8t4C8qt12Cw1HVE",
		"name": "WAVAX"
	},
	{
		"address": "7xKXtg2CW87d97TXJSDpbD5jBkheTqA83TZRuJosgAsU",
		"name": "SAMO"
	},
	{
		"address":"SLNDpmoWTVADgEdndyvWzroNL7zSi1dF9PC3xHGtPwp",
		"name": "SLND"
	},
	{
		"address": "EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp",
		"name": "FIDA"
	},
	{
		"address":"EzfgjvkSwthhgHaceR3LnKXUoRkP6NUhfghdaHAj1tUv",
		"name": "WFTT"
	},
	{
		"address": "kinXdEcpDQeHPEuQnqmUgtYykqKGVFq6CeVX5iAHJq6",
		"name": "KIN"
	},
	{
		"address": "MangoCzJ36AjZyKwVj3VnYU4GTonjfVEnJmvvWaxLac",
		"name": "MNGO"
	},
	{
		"address": "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB",
		"name": "USDT"
	},
	{
		"address": "8ymi88q5DtmdNTn2sPRNFkvMkszMHuLJ1e3RVdWjPa3s",
		"name": "SOLDOGE"
	},
    {
		"address":"9tzZzEHsKnwFL1A3DyFJwj36KnZj3gZ7g4srWp9YTEoh",
		"name": "ARBITRAGE"
	},
    {
		"address":"orcaEKTdK7LKz57vaAYr9QeNsVEPfiu6QeMU1kektZE",
		"name": "ORCA"
	},
    {
		"address":"8FU95xFJhUUkyyCLU13HSzDLs7oC4QZdXQHL6SCeab36",
		"name": "WUNI"
	},
	{
		"address": "5p2zjqCd1WJzAVgcEnjhb9zWDU7b9XVhFhx4usiyN7jB",
		"name": "CATO"
	}
]
